import { motion } from "framer-motion";
import { CONTACT } from "@/data/site";
import { Reveal, SectionHead } from "./Reveal";
import { FamilyPanel } from "./FamilyPanel";

const MEMBERS = [
  ["Cynthia Bossard", "President"],
  ["Mary Bossard", "Vice President"],
  ["Clifford Bossard", "Secretary"],
  ["Ken Bossard", "Treasurer · Mortgage Financing"],
];

export const Family = () => {
  return (
  <section id="family" className="relative py-28 lg:py-40" data-testid="family-section">
    <div className="mx-auto max-w-[1440px] px-6 lg:px-12 grid lg:grid-cols-12 gap-14 items-center">
      <motion.div
        initial={{ opacity: 0, x: -40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-10% 0px" }}
        transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
        className="lg:col-span-6 relative"
        data-testid="family-image"
      >
        <div className="absolute inset-0 bg-gold/10 blur-[80px] rounded-full scale-75" />
        <div className="clip-frame relative bg-ink overflow-hidden">
          <FamilyPanel />
        </div>
        <div className="mt-4 inline-block sm:mt-0 sm:absolute sm:-bottom-6 sm:-right-4 lg:-right-10 bg-obsidian border border-gold/30 px-6 py-5">
          <div className="eyebrow">Registered</div>
          <div className="mt-1 font-serif text-2xl text-ivory">Maryland · {CONTACT.founded}</div>
        </div>
      </motion.div>

      <div className="lg:col-span-5 lg:col-start-8">
        <SectionHead index="05" eyebrow="The Family" title={<>A family firm, built in Maryland.</>} />
        <Reveal delay={0.2}>
          <p className="mt-8 text-ivory/60 leading-relaxed">
            Bossard Investment Group LLC was formed in {CONTACT.founded} in {CONTACT.location}, and operates as{" "}
            <a href={CONTACT.dbaUrl} target="_blank" rel="noreferrer" className="text-gold link-underline" data-testid="family-dba-link">
              Bossard Homes
            </a>{" "}
            for local sellers across the DMV. Our purpose is written into our charter: acquisition, development,
            lending facilitation, and education in credit, real estate and financial literacy.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <ul className="mt-10 grid grid-cols-2 gap-x-8 gap-y-5" data-testid="family-members">
            {MEMBERS.map(([m, role], i) => (
              <li key={m} className="border-t border-gold/20 pt-4">
                <span className="font-mono text-[10px] text-ivory/35">0{i + 1}</span>
                <div className="font-serif text-xl text-ivory mt-1">{m}</div>
                <div className="text-xs text-gold/80 mt-1">{role}</div>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </div>
  </section>
  );
};
